// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"684b9553","387":"804f6797"}[chunkId] + ".chunk.js";
};